// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-iXC","left":"styles_left__1106y"};